import AsyncPage from 'pages/AsyncPage'
import universal from 'react-universal-component'
import { clearDraft, loadDraft } from 'state/actions/drafts'
import { initialiseAttachments } from 'state/actions/attachments'
import { loadPublishedPostById } from 'state/actions/posts'
import { clearEmbeds } from 'state/actions/embeds'

const NO_ATTACHMENTS = Object.freeze({})

const component = universal(props => import('./ComposePostPage'))

class AsyncComposePostPage extends AsyncPage {
  constructor() {
    super({
      title: 'compose.new.page_title',
      pageComponent: component
    })
  }
  async prepareAdditionalAsyncData(dispatch, getState, opts) {
    const { location: { payload: { to, postType, postId } } } = getState()

    dispatch(clearDraft())
    dispatch(clearEmbeds())
    dispatch(initialiseAttachments(NO_ATTACHMENTS))
    if (postId) {
      // load existing from API (we're editing an existing post)
      const draft = await loadDraft({ _id: postId, type: postType })(
        dispatch,
        getState,
        opts
      )
      dispatch(initialiseAttachments(draft.attachments || NO_ATTACHMENTS))

    } else {
      if (to) {
        // creating a response, make sure the post being responded
        // to actually exists, and make it available so that we can
        // display some portion of it ...
        const post = await loadPublishedPostById({ _id: to })(
          dispatch,
          getState,
          opts
        )
      }
    }
  }
}

export default new AsyncComposePostPage()
